export default "__VITE_ASSET__DWHKOjMf__"